import Checkbox from "../../../Form/Checkbox.js";
import { useContext, useEffect, useRef, useState } from "react";
import ToastContext from "../../../../contexts/toast.js";
import { FormUtility } from "../../../Utility/FormUtility.js";
import { useNavigate } from "react-router-dom";
import { RichiestaService } from "../../../../services/RichiestaService.js";
import AlertMessage from "../../../Utility/Alert/AlertMessage.js";
import Modal from "../../../Utility/Modal/Modal.js";
import moment from "moment";
import tuttiComuni from "../../../Utility/json/tuttiComuni.js";

const Step6Ripresentazione = (props) => {
  const [richiesta, setRichiesta] = useState({ ...props.richiesta });
  const previousBtnFunction = props.previousBtnFunction;
  const [validate, setValidate] = useState(false);
  const [inputErrors, setInputErrors] = useState([]);
  const utility = new FormUtility();
  const toastContext = useContext(ToastContext);
  const formRef = useRef(null);
  const [inSave, setInSave] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);
  const title = "Domanda presentata!";
  const content = `La domanda è stata inoltrata correttamente ed è stato attribuito il codice pratica '${richiesta?.codice}'. A seguito dei controlli verrà inviata un’e-mail di conferma dell’inoltro.`;

  const navigate = useNavigate();

  const [informativa1, setInformativa1] = useState(false);
  const [informativa2, setInformativa2] = useState(false);
  const [informativa3, setInformativa3] = useState(false);
  const [comuneResidenza, setComuneResidenza] = useState(null);
  const [comuneDomicilio, setComuneDomicilio] = useState(null);
  const [statiOption, setStatiOption] = useState(null);
  const [comuneBeneficiario, setComuneBeneficiario] = useState(null);
  const ordineGrado = {
    MEDIA: "Scuola secondaria di primo grado (Scuola media)",
    SUPERIORE: "Scuola secondaria di secondo grado (Scuola superiore)",
  };

  const tipoRichiedente = {
    STUDENTE_MAGGIORENNE:
      "Sono uno/a studente/studentessa maggiorenne e sto presentando domanda per me",
    GENITORE: "Sto presentando domanda per mio/a figlio/a",
    TUTORE_LEGALE:
      "Sto presentando domanda per uno/a studente/studentessa di cui sono tutore o legale rappresentante",
  };

  const annoCorso = {
    1: "1° anno",
    2: "2° anno",
    3: "3° anno",
    4: "4° anno",
    5: "5° anno",
    6: "6° anno",
  };

  const titoliStudio = {
    NESSUN_TITOLO: "Nessun Titolo",
    LICENZA_ELEMENTARE: "Licenza elementare",
    LICENZA_MEDIA: "Licenza media",
  };

  const categorieAppartenenza = {
    PERSONE_CON_DISABILITA: "Persone con disabilità",
    SENZA_TETTO:
      "Persone senza tetto o persone colpite da esclusione abitativa",
    APPARTENENTE_MINORANZE: "Appartenente a minoranze a rischio esclusione",
    PARTECIPANTI_ORIGINE_STRANIERA: "Partecipanti di origine straniera",
    CITTADINO_PAESI_TERZI: "Cittadino/a di paesi terzi",
    ZONE_RURALI: "Partecipanti provenienti da zone rurali",
    NESSUNA_DELLE_PRECENDENTI: "Nessuna delle precedenti",
  };

  const condizioneStudente = {
    AMMESSO:
      "Ammesso alla classe successiva per l’A.S. " +
      props.richiesta.bando.annoEducativo +
      " (promosso)",
    NON_AMMESSO:
      "Non ammesso alla classe successiva per l’A.S. " +
      props.richiesta.bando.annoEducativo +
      " (respinto)"
  };

  const fieldDatiIscrizioneScolastica = [
    {
      key: "condizioneStudente",
      label: "Condizione studente",
      options: condizioneStudente,
    },
    {
      key: "cambioIstitutoTipologia",
      label: "Lo studente frequenterà un istituto diverso o una tipologia di scuola diversa rispetto all'A.S " + props.richiesta.bando.annoEducativo + " appena trascorso?",
      isBoolean: true,
    },
    { key: "ordineGrado", label: "Ordine e grado", options: ordineGrado },
    { key: "annoCorso", label: "Anno di corso", options: annoCorso },
    {
      key: "istitutoInToscana",
      label: "L'istituto scolastico ha sede in Toscana?",
      isBoolean: true,
    },
    { key: "comune", label: "Comune", subKey: "denominazione" },
    { key: "plesso", label: "Scuola", subKey: "denominazione" },
    {
      key: "indirizzoDiStudio",
      label: "Indirizzo di studio",
      subKey: "denominazione",
    },
    { key: "regioneScuolaFuoriToscana", label: "Regione" },
    { key: "comuneFuoriToscana", label: "Comune", subKey: "denominazione" },
    { key: "codiceScuolaFuoriToscana", label: "Codice meccanografico" },
    { key: "denominazioneScuolaFuoriToscana", label: "Denominazione" },
  ];

  const fieldDatiUtenteResidenza = [
    {
      key: "statoResidenza",
      label: "Stato",
      subKey: "nome",
      options: statiOption,
    },
    { key: "provRes", label: "Provincia" },
    {
      key: "comuneResidenza",
      label: "Comune",
      subKey: "denominazione",
      options: comuneResidenza,
    },
    { key: "viaResidenza", label: "Via" },
    { key: "civicoResidenza", label: "Numero civico" },
    { key: "capResidenza", label: "CAP" },
    {
      key: "domicilioComeResidenza",
      label: "La residenza coincide con il domicilio",
      isBoolean: true,
    },
  ];

  const fieldDatiUtenteDomicilio = [
    {
      key: "statoDomicilio",
      label: "Stato",
      subKey: "nome",
      options: statiOption,
    },
    { key: "provDom", label: "Provincia" },
    {
      key: "comuneDomicilio",
      label: "Comune",
      subKey: "denominazione",
      options: comuneDomicilio,
    },
    { key: "viaDomicilio", label: "Via" },
    { key: "civicoDomicilio", label: "Numero civico" },
    { key: "capDomicilio", label: "CAP" },
  ];

  const fieldDatiUtente = [
    { key: "codiceFiscale", label: "Codice fiscale" },
    { key: "nome", label: "Nome" },
    { key: "cognome", label: "Cognome" },
    { key: "cittadinanza", label: "Cittadinanza" },
    { key: "email", label: "Email" },
    { key: "pec", label: "PEC" },
    { key: "telefono", label: "Cellulare" },
  ];

  const fieldDatiBeneficiario = [
    { key: "codiceFiscale", label: "Codice fiscale" },
    { key: "nome", label: "Nome" },
    { key: "cognome", label: "Cognome" },
    { key: "cittadinanza", label: "Cittadinanza" },
    { key: "dataNascita", label: "Data di nascita" },
    { key: "eta", label: "Età" },
    {
      key: "statoResidenza",
      label: "Stato",
      subKey: "nome",
      options: statiOption,
    },
    { key: "provRes", label: "Provincia" },
    { key: "comuneResidenza", label: "Comune", options: comuneBeneficiario },
    { key: "viaResidenza", label: "Via" },
    { key: "civicoResidenza", label: "Numero civico" },
    { key: "capResidenza", label: "CAP" },
    {
      key: "titoloDiStudioPosseduto",
      label: "Titolo di studio posseduto",
      options: titoliStudio,
    },
    {
      key: "categoriaAppartenenzaStudente",
      label: "Categoria di appartenenza",
      options: categorieAppartenenza,
    },
  ];

  const richiestaService = new RichiestaService();

  const map = {
    informativa1: setInformativa1,
    informativa2: setInformativa2,
    informativa3: setInformativa3,
  };

  const handleModalAction = () => {
    navigate("/dashboard");
  };

  const onChangeValue = (event) => {
    const target = event.target;
    const set = map[target.name];
    set(target.checked === true);
    if (validate) {
      setFormErrors(false);
    }
  };

  const onPrevBtnClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    previousBtnFunction();
  };

  const setFormErrors = (setFocus = true) => {
    const errors = utility.getAllInputErrors(formRef);
    setInputErrors(errors.map((el) => el.id));
    if (setFocus && errors.length > 0) {
      errors[0].focus();
    }
  };

  const getComuneResidenza = (id) => {
    if (!id) {
      setComuneResidenza(null);
      return;
    }

    const comune = [...tuttiComuni].filter((el) => el.id === id);
    setComuneResidenza(comune && comune.length > 0 ? comune[0] : null);
  };

  const getComuneDomicilio = (id) => {
    if (!id) {
      setComuneDomicilio(null);
      return;
    }

    const comune = [...tuttiComuni].filter((el) => el.id === id);
    setComuneDomicilio(comune && comune.length > 0 ? comune[0] : null);
  };

  useEffect(() => {
    if (props.nazioni) {
      setStatiOption([...props.nazioni]);
    }
  }, [props.nazioni]);

  useEffect(() => {
    const rdr = richiesta?.richiestaDatiRichiedente;
    if (rdr?.comuneResidenza !== comuneResidenza?.id) {
      getComuneResidenza(rdr?.comuneResidenza);
    }

    if (rdr?.comuneDomicilio !== comuneDomicilio?.id) {
      getComuneDomicilio(rdr?.comuneDomicilio);
    }
  }, [richiesta?.richiestaDatiRichiedente]);

  useEffect(() => {
    if (richiesta.richiestaDatiBeneficiario?.comuneResidenza) {
      const comune = [...tuttiComuni].filter(
        (el) =>
          el.id === richiesta.richiestaDatiBeneficiario?.comuneResidenza ?? -1
      );
      setComuneBeneficiario(comune && comune.length > 0 ? comune[0] : null);
    }
  }, [richiesta?.richiestaDatiBeneficiario]);

  useEffect(() => {
    setRichiesta({ ...props.richiesta });
  }, [props.richiesta]);

  useEffect(() => {
    if (richiesta.richiestaIscrizioneScolastica?.comuneFuoriToscanaId) {
      const comune = [...tuttiComuni].find(
        (el) =>
          el.id ===
            richiesta.richiestaIscrizioneScolastica?.comuneFuoriToscanaId ?? -1
      );

      if (comune.id === richiesta.richiestaIscrizioneScolastica.comuneFuoriToscana?.id) {
        return;
      }

      setRichiesta((prevRichiesta) => ({
        ...prevRichiesta,
        richiestaIscrizioneScolastica: {
          ...prevRichiesta.richiestaIscrizioneScolastica,
          comuneFuoriToscana: comune,
        },
      }));
    }
  }, [richiesta?.richiestaIscrizioneScolastica]);

  const printDataIscrizioneScolastica = (el) => {
    const value = richiesta.richiestaIscrizioneScolastica?.[el.key];

    if (el.isBoolean) {
      return value ? el.trueValue ?? "Sì" : el.falseValue ?? "No";
    }

    if (el.subKey) {
      if (el.key === "plesso")
        return `${value?.[el.subKey]} [${value?.codice}]`;
      return value?.[el.subKey] || "";
    }

    return el.options ? el.options[value] : value || "";
  };

  const printValue = (el, obj) => {
    if (!obj) return;
    const value = obj?.[el.key];

    if (el.key === "dataNascita") {
      return moment(value, "YYYY-MM-DD").format("DD/MM/YYYY");
    }

    if (el.key === "telefono") {
      return obj?.prefisso + value;
    }

    if (el.isBoolean) {
      return value ? "Sì" : "No";
    }

    if (["comuneResidenza", "comuneDomicilio"].includes(el.key)) {
      return el.options ? el.options?.denominazione : "";
    }

    if (el.subKey) {
      if (el.options)
        return el.options?.find((item) => item.id === value)?.[el.subKey];
      return value?.[el.subKey] || "";
    }

    return el.options ? el.options[value] : value || "";
  };

  const presentaDomanda = () => {
    setValidate(true);
    const validity = formRef.current.checkValidity();
    if (!validity) {
      setFormErrors();
      return;
    }
    setInSave(true);
    richiestaService
      .presentaDomandaRiapertura(richiesta.id)
      .then((res) => {
        setModalOpen(true);
        setInSave(false);
      })
      .catch((err) => {
        toastContext.error(utility.getErrorMsg(err), 2500);
        setInSave(false);
      });
  };

  const fieldsSchoolToExclude = (istitutoInToscana, fieldsToExclude) => {
    switch (istitutoInToscana) {
      case true:
        fieldsToExclude.push("regioneScuolaFuoriToscana");
        fieldsToExclude.push("comuneFuoriToscana");
        fieldsToExclude.push("codiceScuolaFuoriToscana");
        fieldsToExclude.push("denominazioneScuolaFuoriToscana");
        fieldsToExclude.push("istitutoInToscana");
        break;
      case false:
        fieldsToExclude.push("comune");
        fieldsToExclude.push("plesso");
        fieldsToExclude.push("indirizzoDiStudio");
        break;
      default:
        fieldsToExclude.push("regioneScuolaFuoriToscana");
        fieldsToExclude.push("comuneFuoriToscana");
        fieldsToExclude.push("codiceScuolaFuoriToscana");
        fieldsToExclude.push("denominazioneScuolaFuoriToscana");
        fieldsToExclude.push("istitutoInToscana");
        fieldsToExclude.push("comune");
        fieldsToExclude.push("plesso");
        fieldsToExclude.push("indirizzoDiStudio");
        break;
    }
  }

  return (
    <div className=" rtds-my-12">
      <div className="rtds-mb-6 ">
        <h1 className="rtds-text-2xl rtds-font-bold">
          Riepilogo{" "}
          {richiesta.statoRichiesta === "BOZZA" ? (
            richiesta?.canBeSaved ? (
              "e Inoltro domanda"
            ) : (
              ""
            )
          ) : (
            <span className="rtds-content-02">{richiesta.codice}</span>
          )}
        </h1>
      </div>

      {/* <h3 hidden={richiesta?.statoRichiesta !== "BOZZA"}>Verificare tutti i dati inseriti prima dell’inoltro della domanda</h3> */}

      <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
        {/*<div className="rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02">
          <p>
            I campi obbligatori sono contrassegnati da un asterisco&nbsp;
            <abbr
              className="rtds-font-bold rtds-no-underline"
              title="obbligatorio"
            >
              *
            </abbr>
          </p>
        </div>*/}

        <form
          noValidate
          ref={formRef}
          id="hasValidationForm"
          className="has-js-validation-form rtds-py-6 rtds-space-y-4"
        >
          <div className="">
            {/*<h2 className="rtds-text-xl rtds-font-bold">
              Dati del richiedente
            </h2>*/}

            <ul
              role="list"
              className="rtds-grid rtds-gap-4 md:rtds-grid-cols-2"
            >
              <li className="rtds-col rtds-h-full ">
                <div className="rtds-card rtds-bg-gradient-04 rtds-group/card rtds-card--widget rtds-card--information">
                  <div className="rtds-card__content">
                    <div className="rtds-card__heading">
                      <h2 className="rtds-card__title">Dati del richiedente</h2>
                    </div>
                    <div className="rtds-card__description">
                      {fieldDatiUtente.map((field) => (
                        <p
                          key={field.key}
                          className="rtds-mb-3 rtds-flex rtds-justify-between rtds-border-b pb-2 rtds-border-gray-02"
                        >
                          <span className="rtds-font-semibold ">
                            {field.label}:
                          </span>
                          <span className="rtds-content-02 rtds-font-semibold ">
                            {printValue(
                              field,
                              richiesta?.richiestaDatiRichiedente
                            )}
                          </span>
                        </p>
                      ))}
                      <h3 className="rtds-heading-5 rtds-mb-4 rtds-mt-6  border-b pb-2 rtds-border-secondary rtds-content-02">
                        Residenza
                      </h3>
                      {fieldDatiUtenteResidenza.map((field) => (
                        <p
                          key={field.key}
                          className="rtds-mb-3 rtds-flex rtds-justify-between rtds-border-b pb-2 rtds-border-gray-02"
                        >
                          <span className="rtds-font-semibold ">
                            {field.label}:
                          </span>
                          <span className="rtds-content-02 rtds-font-semibold ">
                            {printValue(
                              field,
                              richiesta?.richiestaDatiRichiedente
                            )}
                          </span>
                        </p>
                      ))}

                      <h3 className="rtds-heading-5 rtds-mb-4 rtds-mt-6  border-b pb-2 rtds-border-secondary rtds-content-02">
                        Domicilio
                      </h3>
                      {fieldDatiUtenteDomicilio.map((field) => (
                        <p
                          key={field.key}
                          className="rtds-mb-3 rtds-flex rtds-justify-between rtds-border-b pb-2 rtds-border-gray-02"
                        >
                          <span className="rtds-font-semibold ">
                            {field.label}:
                          </span>
                          <span className="rtds-content-02 rtds-font-semibold ">
                            {printValue(
                              field,
                              richiesta?.richiestaDatiRichiedente
                            )}
                          </span>
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </li>

              <li className="rtds-col ">
                <div className="rtds-card rtds-bg-gradient-04 rtds-group/card rtds-card--widget rtds-card--information  rtds-h-full">
                  <div className="">
                    <div className="rtds-card__content">
                      <div className="rtds-card__heading">
                        <h2 className="rtds-card__title">
                          Rapporto col beneficiario
                        </h2>
                      </div>
                      <div className="rtds-card__description">
                        <p className="rtds-mb-3 rtds-flex rtds-justify-between rtds-border-b pb-2 rtds-border-gray-02">
                          <span className="rtds-font-semibold">
                            Soggetto per il quale si presenta la domanda di
                            partecipazione:
                          </span>
                          <span className="rtds-content-02 rtds-font-semibold">
                            {
                              tipoRichiedente[
                                richiesta?.richiestaRapportoBeneficiario
                                  ?.tipoRichiedente
                              ]
                            }
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="">
                    <div className="rtds-card__content">
                      <div className="rtds-card__heading">
                        <h2 className="rtds-card__title">
                          Dati del beneficiario
                        </h2>
                      </div>
                      <div className="rtds-card__description">
                        {fieldDatiBeneficiario.map((field) => (
                          <p
                            key={field.key}
                            className="rtds-mb-3 rtds-flex rtds-justify-between rtds-border-b pb-2 rtds-border-gray-02"
                          >
                            <span className="rtds-font-semibold">
                              {field.label}:
                            </span>
                            <span className="rtds-content-02 rtds-font-semibold ">
                              {printValue(
                                field,
                                richiesta?.richiestaDatiBeneficiario
                              )}
                            </span>
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li className="rtds-col ">
                <div className="rtds-card rtds-bg-gradient-04 rtds-group/card rtds-card--widget rtds-card--information">
                  <div className="rtds-card__content">
                    <div className="rtds-card__heading">
                      <h2 className="rtds-card__title">
                        Dati sull'iscrizione scolastica
                      </h2>
                    </div>
                    <div className="rtds-card__description">
                      {fieldDatiIscrizioneScolastica
                        .filter((field) => {
													const iscrizioneScolastica = richiesta?.richiestaIscrizioneScolastica;

                          const istitutoInToscana = iscrizioneScolastica?.istitutoInToscana;
                          const toExclude = [];
                          if (istitutoInToscana === null) {
                            toExclude.push("istitutoInToscana");
                          }

                          const condizioneStudente = iscrizioneScolastica?.condizioneStudente;
                          switch (condizioneStudente) {
                            case "NON_AMMESSO":
                              const cambioIstitutoTipologia = iscrizioneScolastica?.cambioIstitutoTipologia;
															if (cambioIstitutoTipologia === null) {
																toExclude.push("inserimentoDatiIscrizioneSecondoAccesso");
															}
                              break;
                            default:
                              toExclude.push("cambioIstitutoTipologia");
                              break;
                          }

                          fieldsSchoolToExclude(istitutoInToscana, toExclude);

													if (toExclude.includes(field.key)) {
														return false;
													}

                          return true;
                        })
                        .map((field) => (
                          <p
                            key={field.key}
                            className="rtds-mb-3 rtds-flex rtds-justify-between rtds-border-b pb-2 rtds-border-gray-02"
                          >
                            <span className="rtds-font-semibold">
                              {field.label}:
                            </span>
                            <span className="rtds-content-02 rtds-font-semibold ">
                              {printDataIscrizioneScolastica(field)}
                            </span>
                          </p>
                        ))}
                    </div>
                  </div>
                </div>
              </li>

              <li className="rtds-col ">
                <div className="rtds-card rtds-bg-gradient-04 rtds-group/card rtds-card--widget rtds-card--information  rtds-h-full">
                  <div className="rtds-card__content">
                    <div className="rtds-card__heading">
                      <h2 className="rtds-card__title">
                        Dati ISEE e di pagamento
                      </h2>
                    </div>
                    <div className="rtds-card__description">
                      <p
                        key="dsu"
                        className="rtds-mb-3 rtds-flex rtds-justify-between rtds-border-b pb-2 rtds-border-gray-02"
                      >
                        <span className="rtds-font-semibold">
                          Numero di protocollo della DSU:
                        </span>
                        <span className="rtds-content-02 rtds-font-semibold ">
                          {richiesta?.richiestaDatiPagamento?.dsu}
                        </span>
                      </p>
                      <p
                        key="iban"
                        className="rtds-mb-3 rtds-flex rtds-justify-between rtds-border-b pb-2 rtds-border-gray-02"
                      >
                        <span className="rtds-font-semibold">IBAN:</span>
                        <span className="rtds-content-02  rtds-font-semibold">
                          {richiesta?.richiestaDatiPagamento?.iban}
                        </span>
                      </p>
                      <p
                        key="denominazioneBanca"
                        className="rtds-mb-3 rtds-flex rtds-justify-between rtds-border-b pb-2 rtds-border-gray-02"
                      >
                        <span className="rtds-font-semibold">Nome banca:</span>
                        <span className="rtds-content-02  rtds-font-semibold">
                          {
                            richiesta?.richiestaDatiPagamento
                              ?.denominazioneBanca
                          }
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <div className="rtds-flex rtds-flex-wrap"></div>

            <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

            <div className="rtds-mb-6">
              <fieldset className="rtds-input-field rtds-gap-2">
                <legend className="rtds-input-field__label">
                  {"Dichiaro: "}
                </legend>

                <Checkbox
                  classDiv={"rtds-input-checkbox rtds-input--lg"}
                  id={"informativa1"}
                  classLabel={"rtds-mr-8"}
                  label={
                    "di essere consapevole che, nel caso di ottenimento del contributo, possono essere eseguiti controlli, anche da parte della Guardia di Finanza, in applicazione dell'art.  4, commi  2  e  8,  del  D.Lgs.  n.109  del  31 marzo  1998,  in materia di controllo della veridicità delle informazioni fornite; "
                  }
                  inputErrors={inputErrors}
                  onChange={onChangeValue}
                  checked={
                    informativa1 ||
                    richiesta?.statoRichiesta !== "BOZZA" ||
                    false
                  }
                  required={richiesta?.statoRichiesta === "BOZZA"}
                  disabled={
                    richiesta?.statoRichiesta !== "BOZZA" ||
                    !richiesta?.canBeSaved
                  }
                />

                <Checkbox
                  classDiv={"rtds-input-checkbox rtds-input--lg"}
                  classLabel={"rtds-mr-8"}
                  id={"informativa2"}
                  label={
                    "di essere consapevole delle sanzioni penali nel caso di dichiarazioni non veritiere, di formazione o uso di atti falsi, richiamate dall'art. 76 del D.P.R. 28.12.2000, n. 445;"
                  }
                  inputErrors={inputErrors}
                  onChange={onChangeValue}
                  checked={
                    informativa2 ||
                    richiesta?.statoRichiesta !== "BOZZA" ||
                    false
                  }
                  required={richiesta?.statoRichiesta === "BOZZA"}
                  disabled={
                    richiesta?.statoRichiesta !== "BOZZA" ||
                    !richiesta?.canBeSaved
                  }
                />
                <Checkbox
                  classDiv={"rtds-input-checkbox rtds-input--lg"}
                  classLabel={"rtds-mr-8"}
                  id={"informativa3"}
                  label={
                    "di avere diritto al contributo in quanto esistono le condizioni di spettanza alla data di presentazione della domanda, impegnandosi a comunicare le eventuali successive variazioni secondo la procedura esposta nell'Avviso Libri Gratis, di cui si invita a prendere attenta e completa visione."
                  }
                  inputErrors={inputErrors}
                  onChange={onChangeValue}
                  checked={
                    informativa3 ||
                    richiesta?.statoRichiesta !== "BOZZA" ||
                    false
                  }
                  required={richiesta?.statoRichiesta === "BOZZA"}
                  disabled={
                    richiesta?.statoRichiesta !== "BOZZA" ||
                    !richiesta?.canBeSaved
                  }
                />
              </fieldset>
              {/* <h2 className="rtds-text-lg rtds-font-bold">Dichiaro:</h2> */}
            </div>

            <div
              hidden={richiesta?.statoRichiesta !== "BOZZA"}
              className="rtds-mb-6"
            >
              <AlertMessage
                title="Attenzione!"
                message="Verificare tutti i dati inseriti prima dell’inoltro della domanda"
                classDiv={""}
                classArticle={""}
                iconName={"mini--information-circle"}
              />
            </div>

            <div
              className="rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center"
              hidden={
                richiesta?.statoRichiesta !== "BOZZA" || !richiesta?.canBeSaved
              }
            >
              <div className="rtds-form-actions">
                <div
                  className="rtds-inline-flex rtds-gap-1"
                  role="group"
                  aria-label="Ruolo"
                >
                  <button
                    onClick={onPrevBtnClick}
                    type="button"
                    className="rtds-btn rtds-btn--secondary rtds-btn--icon-left rtds-group/button rtds-form-submit"
                  >
                    <svg
                      className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6  group-hover/button:-rtds-translate-x-1"
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                      />
                    </svg>{" "}
                    Indietro
                  </button>
                  <button
                    type="button"
                    className="rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button"
                    disabled={inSave}
                    aria-busy={inSave}
                    onClick={presentaDomanda}
                  >
                    {"Presenta domanda"}

                    {inSave ? (
                      <>
                        <svg
                          className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                          aria-hidden="true"
                          focusable="false"
                          role="img"
                        >
                          <use
                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                          />
                        </svg>
                        <span className="rtds-sr-only">Caricamento...</span>
                      </>
                    ) : (
                      <>
                        <svg
                          className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                          aria-hidden="true"
                          focusable="false"
                          role="img"
                        >
                          <use
                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                          />
                        </svg>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <Modal
        isOpen={isModalOpen}
        title={title}
        content={content}
        onAction={handleModalAction}
        actionLabel="Chiudi"
        closeLabel="Annulla"
        hideCloseButton={true}
        icona={true}
        iconaClass={"solid--check-circle"}
        iconaColorClass={"rtds-text-success-dark"}
      />
    </div>
  );
};

export default Step6Ripresentazione;
